export default "__VITE_ASSET__c1159982__"